var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters.currentItemVariation &&
    _vm.$store.getters.currentItemVariation.item &&
    _vm.$store.getters.currentItemVariation.item.free5
    ? _c("div", { staticClass: "container-max" }, [
        _c("div", { staticClass: "responsive-iframe--video" }, [
          _c("iframe", {
            attrs: {
              src:
                "https://www.youtube.com/embed/" +
                _vm.$store.getters.currentItemVariation.item.free5,
              frameborder: "0",
              allow:
                "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: ""
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }